<template>
  <el-dialog :title="title" :visible.sync="visible" width="680px" :before-close="close">
    <el-form :model="form" :rules="rules" ref="form" label-width="80px">
      <el-form-item label="文件ID" prop="fileId">
        <span v-if="title === '更新文件'" class="file-id">{{ form.fileId }}</span>
        <span v-else class="file-id">自动生成</span>
      </el-form-item>

      <el-form-item label="文件名称" prop="fileName">
        <el-input v-model="form.fileName" :disabled="title === '更新文件'" size="medium" maxlength="50" show-word-limit placeholder="请输入" />
      </el-form-item>

      <el-form-item label="客户邮箱" prop="email">
        <el-select v-model="form.email" :disabled="title === '更新文件'" size="medium" placeholder="请选择" @change="selectUserEmail">
          <el-option v-for="item in userOptions" :key="item.userId" :label="item.email" :value="item.email" />
        </el-select>
        <el-checkbox v-model="form.ifSendEmail">邮件通知客户</el-checkbox>
      </el-form-item>

      <el-form-item label="上传文件" prop="fileUrl">
        <div v-if="form.fileUrl" class="uploaded" @click="resetUpload">
          <p class="file-name">{{ defaultTips(fileName) }}</p>
          <p class="reset-upload">重新上传</p>
        </div>
        <div v-else v-loading="fileLoading" class="uploading">
          <el-upload drag action="#" :multiple="false" :before-upload="beforeUpload">
            <i class="el-icon-upload" />
            <div class="upload-tips-text">
              <em>点击</em>或将文件<em>拖拽</em>到这里上传
              <br />
              支持扩展名：csv
            </div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">取 消</el-button>
      <el-button :loading="saveLoading" type="primary" size="medium" @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import API from '@/api'
import { validateEnglishNumberUnderline } from '@/utils/validate'

let form = {
  id: undefined,
  userId: undefined,
  fileId: undefined,
  fileName: undefined,
  email: undefined,
  userName: undefined,
  ifSendEmail: false, // 0.否 1.是
  fileUrl: undefined
}

let validateFileName = (rule, value, callback) => {
  if (value) {
    if (validateEnglishNumberUnderline(value)) {
      callback()
    } else {
      callback(new Error('文件名称只能填写英文、数字、下划线'))
    }
  } else {
    callback(new Error('请输入文件名称'))
  }
}

export default {
  data() {
    return {
      title: '上传新文件',
      visible: false,

      fileLoading: false,

      saveLoading: false,

      userOptions: [
        { userId: '10042369', email: 'z.seven0209@gmail.com', fullName: 'Swan' },
        { userId: '10023343', email: 'smartthreads@me.com', fullName: 'Donare Inc.' }
      ],
      // 查询用户列表的请求参数
      userParameter: {
        email: undefined, // 查询关键字
        pageNumber: 1,
        pageSize: 20,
        users: []
      },

      form: { ...form },

      fileName: undefined, // 选择的文件名称

      rules: {
        fileName: [{ required: true, validator: validateFileName, trigger: 'change' }],
        email: [{ required: true, message: '请选择客户邮箱', trigger: 'change' }],

        fileUrl: [{ required: true, message: '请上传文件', trigger: 'change' }]
      }
    }
  },
  computed: {
    defaultTips() {
      return (value) => value || '-'
    }
  },
  methods: {
    /**
     * API 新增或编辑跟单文件
     */
    async addOrEditDocumentaryFile() {
      try {
        this.confirmLoading = true
        let query = { ...this.form }
        query.ifSendEmail = query.ifSendEmail ? 1 : 0
        let { code, message } = await API.addOrEditDocumentaryFile(query)
        if (code === 10000) {
          this.$message.success(message)
        } else {
          this.$message.error(message)
        }
        this.confirmLoading = false
      } catch (error) {
        this.confirmLoading = false
      }
    },

    /**
     * 选择用户邮箱
     *
     * @param {Array} value 目前的选中值
     */
    selectUserEmail(value) {
      this.userOptions.forEach((item) => {
        if (item.email === value) {
          this.form.userId = item.userId
          this.form.userName = item.fullName
        }
      })
    },

    /**
     * 文件上传时的钩子
     *
     * @param {Blob} file 上传的文件
     */
    beforeUpload(file) {
      try {
        if (this.form.fileName) {
          this.fileLoading = true
          if (file.type === 'text/csv') {
            API.signValue({ directory: 'documentary/file/' }).then(({ data }) => {
              let formData = new FormData()
              formData.append('directory', 'documentary/file/')
              formData.append('signValue', data)
              formData.append('file', file)
              formData.append('fileName', this.form.fileName)
              API.uploadExcelFile(formData).then((result) => {
                if (result.code === 10000) {
                  this.fileName = file.name
                  this.form.fileUrl = result.data
                } else {
                  this.$message.error(result.message)
                }
              })
            })
          } else {
            this.$message.warning('仅支持扩展名.csv的文件，请重新选择！')
          }
          this.fileLoading = false
        } else {
          this.$message.warning('请先填写文件名称！')
        }
      } catch (error) {
        this.fileLoading = false
      }
      return false
    },

    /**
     * 重新上传
     */
    resetUpload() {
      this.fileName = undefined
      this.form.fileUrl = undefined
    },

    /**
     * 显示对话框
     *
     * @param {Object} payload 编辑时为当前行对象
     */
    show(payload) {
      if (payload) {
        // 编辑
        this.title = '更新文件'
        this.fileName = payload.fileName
        Object.assign(this.form, payload)
      }
      this.visible = true
    },

    /**
     * 保存
     */
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.addOrEditDocumentaryFile()
          this.close()
          this.$emit('update')
        } else {
          return false
        }
      })
    },

    /**
     * 关闭对话框
     */
    close() {
      this.clear()
      this.visible = false
    },

    /**
     * 负责清除数据
     */
    clear() {
      this.title = '上传新文件'
      this.form = { ...form }
      this.userOptions = [
        { userId: '10042369', email: 'z.seven0209@gmail.com', fullName: 'Swan' },
        { userId: '10023343', email: 'smartthreads@me.com', fullName: 'Donare Inc.' }
      ]
      this.userParameter = {
        email: undefined,
        pageNumber: 1,
        pageSize: 20,
        users: []
      }
      this.fileName = undefined
      this.temporaryFileName = undefined
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.uploaded {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 360px;
  height: 180px;
  margin-bottom: 15px;
  background-color: #fff;
  border: 1px dashed #d9d9d9;
  overflow: hidden;
  cursor: pointer;
  border-radius: 6px;
}

.uploading {
  width: 360px;
  height: 180px;
  border-radius: 6px;
}

.file-id {
  color: #f56c6c;
}

.el-input,
.el-select {
  width: 398px;
}

.el-checkbox {
  margin-left: 15px;
}

.upload-tips-text {
  line-height: 28px;
}

em {
  color: #99c41c;
  font-style: normal;
}

.file-name,
.reset-upload {
  color: #99c41c;
  line-height: 16px;
  margin: 5px 0;
}

.reset-upload {
  color: #f56c6c;
}
</style>
